import { FlexAlign, FlexGap, FlexJustify, StackHorizontal, StackVertical } from '@ukpostbox/frontend-framework';
import { FieldValues, FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';
import { useLocation } from 'react-router';
import { CreateRuleset } from '../../Components/Rulesets/CreateRuleset';

function AddRuleset() {
	const location = useLocation();

	const formMethods = useForm({
		mode: 'onChange',
		defaultValues: {
			name: location.state?.name || '',
			scanType: location.state?.scanType || -1,
			action: location.state?.action || { id: -1 },
			filters: location.state?.filters || [{}],
			applyToExisting: location.state?.applyToExisting || false,
		},
	});

	/*    useEffect(() => {
        const subscription = formMethods.watch((e) => {
            console.log('watch', e);
        });

        return () => subscription.unsubscribe();
    }, [formMethods.watch]); */

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>New Ruleset</h2>
			</StackHorizontal>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit((data: FieldValues) => console.log('SUBMIT', data))}>
					<fieldset>
						<StackVertical gap={FlexGap.Medium}>
							<CreateRuleset />
						</StackVertical>
					</fieldset>
				</form>
			</FormProvider>
		</>
	);
}

export default AddRuleset;
